// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.date-time-btn {
  margin-right: 5px;
  --background: var(--ion-color-background);
}

.groups {
  padding-left: 30px;
}

.add-event-btn {
  width: 90%;
}

ion-datetime-button::part(native) {
  background: var(--ion-color-light-shade);
}

.logo {
  margin: 5px;
  height: 35px;
}

.portal-header {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
}

.event-visibility {
  display: flex;
  flex-direction: row;
  align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/app/modals/create-event-modal/create-event-modal.page.scss"],"names":[],"mappings":"AAAA;EACE,iBAAA;EACA,yCAAA;AACF;;AAEA;EACE,kBAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,wCAAA;AACF;;AAEA;EACE,WAAA;EACA,YAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,mBAAA;AACF","sourcesContent":[".date-time-btn {\r\n  margin-right: 5px;\r\n  --background: var(--ion-color-background);\r\n}\r\n\r\n.groups {\r\n  padding-left: 30px;\r\n}\r\n\r\n.add-event-btn {\r\n  width: 90%;\r\n}\r\n\r\nion-datetime-button::part(native) {\r\n  background: var(--ion-color-light-shade);\r\n}\r\n\r\n.logo {\r\n  margin: 5px;\r\n  height: 35px;\r\n}\r\n\r\n.portal-header {\r\n  display: flex;\r\n  flex-direction: row;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.event-visibility {\r\n  display: flex;\r\n  flex-direction: row;\r\n  align-items: center;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
